import React from "react";
import { TEMPLATES } from "./templateData";
import { TemplateThumbnail } from "./TemplateThumbnail";

export const TemplateGallery = ({ occasion, selectedTemplate, onSelect }) => {
  const templates = TEMPLATES[occasion] || [];

  return (
    <div data-testid="template-gallery">
      <h2 className="text-2xl sm:text-3xl font-bold text-[#1E1B4B] text-center mb-2">
        Pick a Design
      </h2>
      <p className="text-[#475569] text-center mb-8 text-sm sm:text-base">
        Choose from 10 unique styles — you'll customize everything next
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
        {templates.map((tpl) => (
          <button
            key={tpl.id}
            data-testid={`template-${tpl.id}`}
            onClick={() => onSelect(tpl)}
            className={`relative rounded-xl overflow-hidden border-2 transition-all duration-300 aspect-[3/4] ${
              selectedTemplate?.id === tpl.id
                ? "border-[#E83E8C] shadow-lg scale-[1.03] ring-2 ring-[#E83E8C]/30"
                : "border-[#E8E8E8] hover:border-[#E83E8C]/40 hover:shadow-md"
            }`}
          >
            <TemplateThumbnail template={tpl} />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2">
              <span className="text-white text-xs font-medium">{tpl.name}</span>
            </div>
            {selectedTemplate?.id === tpl.id && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-[#E83E8C] rounded-full flex items-center justify-center">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
